import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class ClientsAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      crew_approve: 0,
      operator: 0,
      name: '',
      address: '',
      city: '',
      province: '',
      country_id: '',
      country_list: [],
      phone: '',
      email: '',
      observations: '',
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.add = this.add.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }
  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/paises/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({country_list: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }); /* Overlay */
    });
  }

  add(event) {
    event.preventDefault();
    var datasave = {
      name: this.state.name,
      address: this.state.address,
      city: this.state.city,
      province: this.state.province,
      country_id: this.state.country_id,
      phone: this.state.phone,
      email: this.state.email,
      observations: this.state.observations,
      crew_approve: this.state.crew_approve,
      operator: this.state.operator,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/cliente', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/cliente/editar/' + responseJson.data.id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        }
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Clientes.AdicionarCliente.titulo}</h3>
      <Link to="/clientes" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Clientes.AdicionarCliente.formulario.Nome}:</label>
              <input type="text" name="name" className="form-control" placeholder={this.locale.Clientes.AdicionarCliente.formulario.placeholder.NomeDoCliente} value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Clientes.AdicionarCliente.formulario.Pais}:</label>
              <Select
                className="form-field-name"
                name="country_id"
                value={this.state.country_id}
                searchable={true}
                placeholder={this.locale.Clientes.AdicionarCliente.formulario.placeholder.SelecionarPais}
                onChange={this.handleSelectChange.bind(this, 'country_id')}
                options={this.state.country_list}
              />    
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Clientes.AdicionarCliente.formulario.Endereco}:</label>
              <input type="text" name="address" className="form-control" placeholder={this.locale.Clientes.AdicionarCliente.formulario.placeholder.EnderecoDoCliente} value={this.state.address} onChange={this.handleChange.bind(this, 'address')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Clientes.AdicionarCliente.formulario.Telefone}:</label>
              <InputMask value={this.state.phone}  maskChar={null} name="phone" mask="(99) 9999-99999" className="form-control" onChange={this.handleChange.bind(this, 'phone')} placeholder={this.locale.Clientes.AdicionarCliente.formulario.placeholder.TelefoneDoCliente} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Clientes.AdicionarCliente.formulario.Cidade}:</label>
              <input type="text" name="city" className="form-control" placeholder={this.locale.Clientes.AdicionarCliente.formulario.placeholder.CidadeDoCliente} value={this.state.city} onChange={this.handleChange.bind(this, 'city')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Clientes.AdicionarCliente.formulario.Email}:</label>
              <input type="text" name="email" className="form-control" placeholder={this.locale.Clientes.AdicionarCliente.formulario.placeholder.EmailDoCliente} value={this.state.email} onChange={this.handleChange.bind(this, 'email')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Clientes.AdicionarCliente.formulario.Estado}:</label>
              <input type="text" name="province" className="form-control" placeholder={this.locale.Clientes.AdicionarCliente.formulario.placeholder.EstadoDoCliente} value={this.state.province} onChange={this.handleChange.bind(this, 'province')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Clientes.AdicionarCliente.formulario.Observacoes}:</label>
              <input type="text" name="observations" className="form-control" value={this.state.observations} onChange={this.handleChange.bind(this, 'observations')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Clientes.AdicionarCliente.formulario.ExigeAprovacaoDosTripulantes}?</label>
              <br/>
              <Toggle
                checked={this.state.crew_approve}
                aria-label=''
                name="crew_approve"
                onChange={this.handleToggleChange.bind(this, 'crew_approve')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Clientes.AdicionarCliente.formulario.Operador}?</label>
              <br/>
              <Toggle
                checked={this.state.operator}
                aria-label=''
                name="operator"
                onChange={this.handleToggleChange.bind(this, 'operator')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Clientes.AdicionarCliente.formulario.botaoAdicionarCliente}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default ClientsAdd;



// WEBPACK FOOTER //
// ./src/Components/Clients/ClientsAdd.js